export default {
  resources: {
    badge: 'الموارد ومركز المعرفة',
    title: 'جميع الموارد',
    subtitle: 'قصص نجاح وأدلة عملية ورؤى قطاعية لمساعدتك على تحسين التوصيل وعمليات الأسطول.',
    successStories: 'قصص النجاح',
    successStoriesSub: 'نتائج حقيقية من فرق توصيل حقيقية',
    learning: 'التعلم',
    learningSub: 'مقالات وورقات بيضاء وأدلة',
    stats: {
      caseStudies: 'دراسات الحالة',
      blogArticles: 'مقالات المدونة',
      whitepapers: 'الورقات البيضاء',
    },
    ctaTitle: 'مستعد لرؤية Geofleet أثناء العمل؟',
    ctaSubtitle: 'ابدأ الآن أو احجز عرضاً للحصول على نتائج مماثلة لعملياتك.',
    ctaTrial: 'ابدأ الآن',
    ctaDemo: 'احجز عرضاً',
    explore: 'استكشف',
    howItWorks: {
      title: 'كيف يعمل',
      subtitle: 'سهل التصفح وسريع للعثور على ما تحتاجه',
    },
    whatsInside: {
      badge: 'ما ستجده',
      title: 'كل ما يقدمه {{name}}',
    },
    whyItMatters: {
      title: 'لماذا يهم',
      subtitle: 'حقائق سريعة عن {{name}}',
    },
    cta: {
      exploreTitle: 'هل أنت مستعد لاستكشاف {{name}}؟',
      exploreSubtitle: 'ابدأ في دقائق. خطط من 100 دولار شهرياً لـ10 سائقين.',
    },
  },
};
